import { createSlice } from '@reduxjs/toolkit';

type Prop = {
  search: any;
  modal: any;
  type: string;
};

const initialState: Prop = {
  search: {
    results: [],
  },
  modal: false,
  type: 'all',
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearch(state, action) {
      state.search = action.payload;
    },
    setModal(state, action) {
      state.modal = action.payload;
    },
    setType(state, action) {
      state.type = action.payload;
    },
  },
});

export const { setSearch, setModal, setType } = searchSlice.actions;
export default searchSlice.reducer;
